var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list-overlay-loader-component-wrapper",class:{ 'hidden': !_vm.active }},[_c('div',{staticClass:"loader background-color-bg-opacity"},[_c('img',{attrs:{"src":`${ require('@/assets/images/loader/loading.gif') }`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }